import { render, staticRenderFns } from "./ModalSendInvoice.vue?vue&type=template&id=1b106f7c&scoped=true"
import script from "./ModalSendInvoice.vue?vue&type=script&lang=js"
export * from "./ModalSendInvoice.vue?vue&type=script&lang=js"
import style0 from "./ModalSendInvoice.vue?vue&type=style&index=0&id=1b106f7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b106f7c",
  null
  
)

export default component.exports